import React from 'react';
import { Col } from 'reactstrap';
import i18n from "../../../i18next";

import SectionTitle from './SectionTitle';
import SearchButton from './SearchButton';
import TimeLineItem from './TimeLineItem';

const CustomerTimeline = props => {

    const { flexSpace, colContainerStyle, mainContainer, timelineContainer } = styles;

    const renderTimeLine = () => {

        return (
            <div style={timelineContainer}>
                {renderTimeLineItems(props.timeline)}
            </div>
        );
    }

    const renderTimeLineItems = items => {

        if (!items || items.length === 0) {
            return null;
        }

        return items.map(item => {
            return (
                <TimeLineItem item={item} currency={props.currency} />
            );
        })
    }

    return (
        <Col style={colContainerStyle}>
            <div style={mainContainer} className="thinScrollbar">
                <div style={flexSpace}>
                    <SectionTitle title={i18n.t('screens:customerInsightScreen.customerTimeline')} />
                    <SearchButton onClick={props.toggleModal} />
                </div>
                {renderTimeLine()}
            </div>
        </Col>
    );
}

export default CustomerTimeline;

const styles = {
    colContainerStyle: {
        padding: '10px'
    },
    mainContainer: {
        backgroundColor: 'white ',
        padding: '0',
        height: '710px',
        overflow: 'scroll',
        overflowX: 'hidden'
    },
    flexSpace: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '5px'
    },
    timelineContainer: {
        margin: '10px 40px',
        padding: '10px 0',
        borderLeft: '2px solid rgb(209,197,211)',
        borderRight: '2px solid rgb(209,197,211)',
        minHeight: '650px',
    },
};


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/CustomerTimeline.js